import React from "react";
import { NavLink } from "react-router-dom";
import { BreadcrumbProps, BreadcrumbItem } from "./types";
import { useTranslate } from "helpers";

const Breadcrumb: React.FC<BreadcrumbProps> = (props) => {
  const { items } = props;
  const { t } = useTranslate();

  return (
    <>
      <div className="relative hidden xl:block">
        <ul className="text-sm ">
          <li className="inline-block relative">
            <NavLink
              to="/"
              className="text-gray-600 mr-2 inline-block after:w-px after:h-4 after:bg-gray-600 "
            >
              <div className="flex group justify-start items-center mr-2">
                <div className="group-hover:text-blue-500">
                  {t("admin.homepage")}
                </div>
              </div>
            </NavLink>
          </li>
          {items &&
            items.map((item: BreadcrumbItem, index: number) => {
              return (
                <li key={index} className="inline-block relative">
                  <NavLink
                    to={item.route}
                    className={
                      "text-gray-600 mr-2 inline-block after:w-px after:h-4 after:bg-gray-600 after:absolute after:bottom-1 after:top-1 after:-left-2 "
                    }
                  >
                    <div className="flex group justify-start items-center mr-2">
                      <div className="group-hover:text-blue-500">
                      {t(item.text)}
                      </div>
                    </div>
                  </NavLink>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export default React.memo(Breadcrumb);
